import { render, staticRenderFns } from "./compervcprice.vue?vue&type=template&id=ff137ffc"
import script from "./compervcprice.vue?vue&type=script&lang=js"
export * from "./compervcprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports